import { render, staticRenderFns } from "./CreatePurchaseOrderFromCommodityDialog.vue?vue&type=template&id=be67b11e&"
import script from "./CreatePurchaseOrderFromCommodityDialog.vue?vue&type=script&lang=ts&"
export * from "./CreatePurchaseOrderFromCommodityDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports